
import React from "react";
import "./OneTimeCleaningService.css";

const OneTimeCleaningService = () => {
  return (
    <div className="onetimecleaning-cleaning-container">
      <h1>A One-Time Deep Refresh When You Need It Most</h1>
      <p>Whether you're preparing for guests, recovering from a party, or just need a reset, our One-Time Cleaning service delivers a complete refresh for your space without the commitment.</p>
      <h2>What’s Included:</h2>
      <ul>
        <li>Dusting and vacuuming of all rooms</li>
<li>Mopping hard floors</li>
<li>Sanitizing kitchen and bathroom surfaces</li>
<li>Emptying trash and deodorizing</li>
<li>Cleaning high-touch surfaces and entryways</li>

      </ul>
    </div>
  );
};

export default OneTimeCleaningService;
